<template>
  <div
    id="app"
  >
    <router-view />
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  components: {},
  setup() {

    return {};
  }
});
</script>

<style lang="scss">

#app {
  width: 100vw;
  max-width: 750px;
  margin: 0 auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
